import VocabulariesView from "@features/tools/view/vocabularies-view";

const Vocabularies = () => {
  return <VocabulariesView />;
};

export default Vocabularies;
